import { actionNameGenerator } from "../../../../utils/commonUtil";

const domainPrefix = "gaw";
const gawActionNameGenerator = actionNameGenerator(domainPrefix);

export const fetchAccountDataType = gawActionNameGenerator('fetchAccountData');
export const accountDataSuccessType = gawActionNameGenerator('accountDataSuccess');
export const makeFromPoolsType = gawActionNameGenerator('makeFromPools');
export const accountDataRequestFailedType = gawActionNameGenerator('accountDataRequestFailed');
export const disclaimerCheckboxType = gawActionNameGenerator('disclaimerCheckbox');
export const switchAccountType = gawActionNameGenerator('switchAccount');
export const fundPoolType = gawActionNameGenerator('fundPool');
export const dataSuccessType = gawActionNameGenerator('dataSuccess');
export const dataFailureType = gawActionNameGenerator('dataFailure');
export const fetchRecentAgreementType = gawActionNameGenerator('fetchRecentAgreement');
export const fetchRecentAgreementLoadingType = gawActionNameGenerator('fetchRecentAgreementLoading');
export const fetchRecentAgreementSuccessType = gawActionNameGenerator('fetchRecentAgreementSuccess');
export const fetchRecentAgreementFailType = gawActionNameGenerator('fetchRecentAgreementFail');
export const fetchSavedCharityType = gawActionNameGenerator('fetchSavedCharity');
export const fetchSavedCharitySuccessType = gawActionNameGenerator('fetchSavedCharitySuccess');
export const fetchSavedCharityFailType = gawActionNameGenerator('fetchSavedCharityFail');
export const fetchGrantHistoryType = gawActionNameGenerator('fetchGrantHistory');
export const fetchGrantHistorySuccessType = gawActionNameGenerator('fetchGrantHistorySuccess');
export const fetchGrantHistoryFailType = gawActionNameGenerator('fetchGrantHistoryFail');
export const fetchPendingAgreementType = gawActionNameGenerator('fetchPendingAgreement');
export const fetchPendingAgreementSuccessType = gawActionNameGenerator('fetchPendingAgreementSuccess');
export const fetchPendingAgreementFailType = gawActionNameGenerator('fetchPendingAgreementFail');
export const removeCharityType = gawActionNameGenerator('removeCharity');
export const removeCharitySuccessType = gawActionNameGenerator('removeCharitySuccess');
export const removeCharityFailType = gawActionNameGenerator('removeCharityFail');
export const selectCharityType = gawActionNameGenerator('selectCharity');
export const saveAgreementType = gawActionNameGenerator('saveAgreement');
export const saveAgreementSuccessType = gawActionNameGenerator('saveAgreementSuccess');
export const saveAgreementFailType = gawActionNameGenerator('saveAgreementFail');
export const advisorAddressAgreementType = gawActionNameGenerator('advisorAddressAgreement');
export const fundPoolUpdatedDataType = gawActionNameGenerator('fundPoolUpdatedData');
export const saveAgreementOneDataReducerType = gawActionNameGenerator('saveAgreementOneDataReducer');
export const newFlowType = gawActionNameGenerator('newFlow');
export const resetFormType = gawActionNameGenerator('resetForm');
export const updateFromCounterWorkerType = gawActionNameGenerator('updateFromCounterWorker');

/** For Search charity */

export const postCharitySearchType = gawActionNameGenerator('postCharitySearch');
export const postCharitySearchSuccessType = gawActionNameGenerator('postCharitySearchSuccess');
export const postCharitySearchFailType = gawActionNameGenerator('postCharitySearchFail');
export const postCitySearchType = gawActionNameGenerator('postCitySearch');
export const postCitySearchSuccessType = gawActionNameGenerator('postCitySearchSuccess');
export const postCitySearchFailType = gawActionNameGenerator('postCitySearchFail');
export const postCountrySearchType = gawActionNameGenerator('postCountrySearch');
export const postCountrySearchSuccessType = gawActionNameGenerator('postCountrySearchSuccess');
export const postCountrySearchFailType = gawActionNameGenerator('postCountrySearchFail');
export const cityLoaderType = gawActionNameGenerator('cityLoader');
export const countryLoaderType = gawActionNameGenerator('countryLoader');
export const geminiFilterType = gawActionNameGenerator('geminiFilter');
export const updateFromCounterType = gawActionNameGenerator('updateFromCounter');
export const updateFromLoadingCounterType = gawActionNameGenerator('updateFromLoadingCounter');
export const updateFromLoadMoreCounterType = gawActionNameGenerator('updateFromLoadMoreCounter');
export const updateFromType = gawActionNameGenerator('updateFrom');
export const einDataType = gawActionNameGenerator('einData');
export const geminiEINDataType = gawActionNameGenerator('geminiEINData');
export const saveCharityType = gawActionNameGenerator('saveCharity');
export const saveCharitySuccessType = gawActionNameGenerator('saveCharitySuccess');
export const saveCharityFailType = gawActionNameGenerator('saveCharityFail');
export const searchTermType = gawActionNameGenerator('searchTerm');
export const searchGeminiType = gawActionNameGenerator('searchGemini');
export const searchGeminiSuccessType = gawActionNameGenerator('searchGeminiSuccess');
export const searchGeminiFailType = gawActionNameGenerator('searchGeminiFail');
export const postGeminiSavedDataType = gawActionNameGenerator('postGeminiSavedData');
export const postGeminiSavedDataSuccessType = gawActionNameGenerator('postGeminiSavedDataSuccess');
export const postGeminiSavedDataFailType = gawActionNameGenerator('postGeminiSavedDataFail');
export const enableEditType = gawActionNameGenerator('enableEdit');
export const resetEditType = gawActionNameGenerator('resetEdit');
export const confirmationPageType = gawActionNameGenerator('confirmationPage');
export const confirmationPageLoadingType = gawActionNameGenerator('confirmationPageLoading');
export const confirmationPageSuccessType = gawActionNameGenerator('confirmationPageSuccess');
export const confirmationPageFailType = gawActionNameGenerator('confirmationPageFail');
export const fetchPoolsType = gawActionNameGenerator('fetchPools');
export const fetchPoolSuccessType = gawActionNameGenerator('fetchPoolSuccess');
export const fetchSpawnsType = gawActionNameGenerator('fetchSpawns');
export const fetchSpawnSuccessType = gawActionNameGenerator('fetchSpawnSuccess');
export const fetchSpawnFailType = gawActionNameGenerator('fetchSpawnFail');
export const addCharityType = gawActionNameGenerator('addCharity');
export const addCharitySuccessType = gawActionNameGenerator('addCharitySuccess');
export const addCharityFailType = gawActionNameGenerator('addCharityFail');
export const cancelSavedCharityType = gawActionNameGenerator('cancelSavedCharity');
export const clearAllReducerType = gawActionNameGenerator('clearAllReducer');
export const clearAllGeminiFilterType = gawActionNameGenerator('clearAllGeminiFilter');
export const geminiSearchTermType = gawActionNameGenerator('geminiSearchTerm');